import React from 'react';
import { Paragraph } from '../Typography';
import { mediaQueries } from 'src/style/breakpoints';

/**
 * @type React.FunctionComponent<{ day: string, month: string, hours: string}>
 */

const FullDate = ({ day, month, hours }) => {
  return (
    <div
      css={{
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        [mediaQueries.tabletPortraitUp]: {
          flex: 1,
        },
      }}
    >
      <div
        css={{
          display: 'flex',
          flexDirection: 'row',
          paddingBottom: 5,
          [mediaQueries.phoneOnly]: {
            flexDirection: 'column',
            paddingRight: 35,
          },
        }}
      >
        <Paragraph
          css={{
            fontSize: 40,
            lineHeight: '28px',
            fontWeight: 'bold',
            padding: 0,
            [mediaQueries.phoneOnly]: {
              fontSize: 30,
              lineHeight: '37px',
            },
          }}
        >
          {day}
        </Paragraph>
        <Paragraph
          css={{
            fontSize: 20,
            lineHeight: '28px',
            fontWeight: 'bold',
            padding: '0 10px',
            [mediaQueries.phoneOnly]: {
              fontSize: 19,
              lineHeight: '18px',
              textAlign: 'left',
              padding: 0,
            },
          }}
        >
          {month}
        </Paragraph>
      </div>
      <Paragraph
        css={{
          fontSize: 15,
          lineHeight: '18px',
          padding: 0,
          paddingTop: 5,
          [mediaQueries.phoneOnly]: {
            display: 'none',
          },
        }}
      >
        {hours}
      </Paragraph>
    </div>
  );
};

export default FullDate;
